module.exports = __webpack_public_path__ + "img/banco.08e35218.svg";